// import { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Box,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";

// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Button,
// } from "@mui/material";
// import { CircularProgress } from "@mui/material";
// import { TextField } from "@mui/material";


// import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import DevicesIcon from "@mui/icons-material/Devices";
// import EditDevice from "./EditDevice";
// import "./ViewDevice.css";
// import apiService from "../../utils/apiservice";
// import AutorenewIcon from "@mui/icons-material/Autorenew";
// import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";





// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// const ViewDevicesSubscription = () => {
//   const [devices, setDevices] = useState([]);
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [deviceToDelete, setDeviceToDelete] = useState(null);
//   const [editOpen, setEditOpen] = useState(false);
//   const [deviceToEdit, setDeviceToEdit] = useState(null);
//   const [sites, setSites] = useState([]);
//   const [selectedSite, setSelectedSite] = useState("all"); // default to All
//   const token = localStorage.getItem("accessToken");
//   const customerId = localStorage.getItem("customer_id");
//   const [deleteMessage, setDeleteMessage] = useState("");
//   const [deleteError, setDeleteError] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [subscriptionOpen, setSubscriptionOpen] = useState(false);
//   const [renewalOpen, setRenewalOpen] = useState(false);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [subscriptionData, setSubscriptionData] = useState({
//     start_date: "",

//   });

//   const [renewalData, setRenewalData] = useState({
//     start_date: "",

//   });


//   // Add these inside your ViewSites component
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   // Add these handlers below your state definitions
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   useEffect(() => {
//     const fetchSites = async () => {
//       try {
//         // const response = await axios({
//         //   url: `${API_URL}/api/get_customer_sites/${customerId}/`,
//         //   method: "GET",
//         //   headers: {
//         //     Authorization: `Bearer ${token}`,
//         //     Accept: "application/json",
//         //     "Content-Type": "application/json",
//         //   },
//         //   data: {}, // 🔥 IMPORTANT: forces Content-Type header
//         // });

//         const response = await apiService({
//           url: `/api/get_customer_sites/${customerId}/`,
//           method: "GET",
//           data: {}, // ✅ keep as it is
//         });

//         const siteData = response.data.data;
//         // setSites(siteData);
//         // if (siteData.length > 0) {
//         //   setSelectedSite(siteData[0].asset_id);
//         // }

//         setSites(siteData);
//         // Only set default to first site if selectedSite is empty
//         if (!selectedSite || selectedSite === "all") {
//           setSelectedSite("all"); // Keep default as "all"
//         }
//       } catch (error) {
//         console.error("Error fetching sites:", error);
//       }
//     };

//     if (customerId) fetchSites();
//   }, [customerId, token]);

//   useEffect(() => {
//     const fetchDevices = async () => {
//       if (!customerId) return;
//       setLoading(true);

//       try {
//         let deviceList = [];

//         if (selectedSite === "all") {
//           // 1️⃣ Fetch all devices for customer
//           const response = await axios.get(
//             `${API_URL}/api/customer_alldevices/${customerId}/?page=0&pageSize=1000`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 Accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               data: {},
//             }
//           );

//           const allDevices = response.data.data.data || [];

//           // Fetch attributes for each device
//           // deviceList = await Promise.all(
//           //   allDevices.map(async (device, index) => {
//           //     let latitude = "-";
//           //     let longitude = "-";
//           //     let is_enabled = false;

//           //     try {
//           //       const attrRes = await axios.get(
//           //         `${API_URL}/api/device_attributes/${device.id.id}/`,
//           //         {
//           //           headers: { Authorization: `Bearer ${token}` },
//           //         }
//           //       );

//           //       const attrsArray = attrRes.data.attributes || [];

//           //       const latitudeAttr = attrsArray.find(attr => attr.key === "latitude");
//           //       const longitudeAttr = attrsArray.find(attr => attr.key === "longitude");
//           //       const activeAttr = attrsArray.find(attr => attr.key === "active");

//           //       latitude = latitudeAttr ? latitudeAttr.value : "-";
//           //       longitude = longitudeAttr ? longitudeAttr.value : "-";
//           //       is_enabled = activeAttr ? activeAttr.value : false;
//           //     } catch (err) {
//           //       console.error(`Error fetching attributes for ${device.id.id}`, err);
//           //     }

//           //     return {
//           //       id: index + 1,
//           //       device_id: device.id.id,
//           //       device_name: device.name,
//           //       latitude,
//           //       longitude,
//           //       is_enabled,

//           //       // ✅ from backend (IMPORTANT FIX)
//           //       subscription_status: device.subscription?.status || "UNSUBSCRIBED",
//           //       start_date: device.subscription?.start_date || null,
//           //       end_date: device.subscription?.end_date || null,
//           //     };
//           //   })
//           // );

//           deviceList = allDevices.map((device, index) => {
//             return {
//               id: index + 1,
//               device_id: device.id.id,
//               device_name: device.name,

//               is_enabled: device.active ?? false,

//               subscription_status: device.subscription?.status || "UNSUBSCRIBED",
//               start_date: device.subscription?.start_date || "-",
//               end_date: device.subscription?.end_date || "-",
//             };
//           });
//         } else {
//           // 2️⃣ Fetch devices for selected site
//           const response = await axios.get(
//             `${API_URL}/api/site_devices/${selectedSite}/`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 Accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               data: {},
//             }
//           );

//           const siteDevices = response.data.devices || [];

//           // Fetch attributes for each device
//           // deviceList = await Promise.all(
//           //   siteDevices.map(async (device, index) => {
//           //     let latitude = "-";
//           //     let longitude = "-";
//           //     let is_enabled = false;

//           //     try {
//           //       const attrRes = await axios.get(
//           //         `${API_URL}/api/device_attributes/${device.device_id}/`,
//           //         {
//           //           headers: { Authorization: `Bearer ${token}` },
//           //         }
//           //       );

//           //       const attrsArray = attrRes.data.attributes || [];

//           //       const latitudeAttr = attrsArray.find(attr => attr.key === "latitude");
//           //       const longitudeAttr = attrsArray.find(attr => attr.key === "longitude");
//           //       const activeAttr = attrsArray.find(attr => attr.key === "active");

//           //       latitude = latitudeAttr ? latitudeAttr.value : "-";
//           //       longitude = longitudeAttr ? longitudeAttr.value : "-";
//           //       is_enabled = activeAttr ? activeAttr.value : false;
//           //     } catch (err) {
//           //       console.error(
//           //         `Error fetching attributes for device ${device.device_id}`,
//           //         err
//           //       );
//           //     }

//           //     return {
//           //       id: index + 1,
//           //       device_id: device.id.id,
//           //       device_name: device.name,
//           //       latitude,
//           //       longitude,
//           //       is_enabled,

//           //       // ✅ from backend (IMPORTANT FIX)
//           //       subscription_status: device.subscription?.status || "UNSUBSCRIBED",
//           //       start_date: device.subscription?.start_date || null,
//           //       end_date: device.subscription?.end_date || null,
//           //     };
//           //   })
//           // );

//           deviceList = siteDevices.map((device, index) => {
//             return {
//               id: index + 1,
//               device_id: device.device_id,
//               device_name: device.device_name,

//               is_enabled: device.active ?? false,

//               subscription_status: device.subscription?.status || "UNSUBSCRIBED",
//               start_date: device.subscription?.start_date || "-",
//               end_date: device.subscription?.end_date || "-",
//             };
//           });
//         }

//         // setDevices(deviceList);


//         // const updatedWithSubscription = await Promise.all(
//         //   deviceList.map(async (device) => {
//         //     try {
//         //       const res = await axios.get(
//         //         `${API_URL}/api/get_subscription_status/${device.device_id}/`,
//         //         {
//         //           headers: {
//         //             Authorization: `Bearer ${token}`,
//         //             Accept: "application/json",
//         //             "Content-Type": "application/json",
//         //           },
//         //         }
//         //       );

//         //       return {
//         //         ...device,
//         //         subscription_status: res.data.status,
//         //       };
//         //     } catch (error) {
//         //       return {
//         //         ...device,
//         //         subscription_status: "UNSUBSCRIBED",
//         //       };
//         //     }
//         //   })
//         // );

//         // setDevices(updatedWithSubscription);
//         setDevices(deviceList);
//       } catch (error) {
//         console.error("Error fetching devices:", error);
//         setDevices([]);
//       }

//       setLoading(false);
//     };

//     fetchDevices();
//   }, [selectedSite, token, customerId]);

//   const handleEditClick = (device) => {
//     setDeviceToEdit(device);
//     setEditOpen(true);
//   };

//   const handleSaveEdit = (updatedDevice) => {
//     // Map through devices and replace the one with the matching ID
//     setDevices(
//       devices.map((d) => (d.id === updatedDevice.id ? updatedDevice : d)),
//     );
//     setEditOpen(false);
//   };

//   const handleDeleteClick = (device) => {
//     setDeviceToDelete(device);
//     setDeleteOpen(true);
//     setDeleteMessage("");
//     setDeleteError(false);
//   };

//   const handleConfirmDelete = async () => {
//     if (!deviceToDelete) return;

//     try {
//       // const response = await axios({
//       //   url: `${API_URL}/api/delete_device/${deviceToDelete.device_id}/`,
//       //   method: "DELETE",
//       //   headers: {
//       //     Authorization: `Bearer ${token}`,
//       //     Accept: "application/json",
//       //     "Content-Type": "application/json",
//       //   },
//       //   data: {},
//       // });
//       const response = await apiService({
//         url: `/api/delete_device/${deviceToDelete.device_id}/`,
//         method: "DELETE",
//         data: {}, // ✅ keep
//       });

//       // ✅ Success
//       const msg = response.data.message || "Device deleted successfully!";
//       setDeleteMessage(msg);
//       setDeleteError(false);

//       // Optional toast
//       // toast.success(msg);

//       setTimeout(() => {
//         setDevices(devices.filter((d) => d.id !== deviceToDelete.id));
//         setDeleteOpen(false);
//         setDeleteMessage("");
//       }, 1500);
//     } catch (error) {
//       console.error("Error deleting device:", error);

//       const backendMessage =
//         error.response?.data?.error ||
//         error.response?.data?.message ||
//         "Failed to delete device.";

//       setDeleteMessage(backendMessage);
//       setDeleteError(true);

//       // toast.error(backendMessage);
//     }
//   };
//   const handleCancelDelete = () => {
//     setDeleteOpen(false);
//     setDeleteMessage("");
//     setDeleteError(false);
//   };


//   const handleSubscriptionClick = (device) => {
//     setSelectedDevice(device);
//     setSubscriptionOpen(true);
//   };

//   const handleRenewalClick = (device) => {
//     setSelectedDevice(device);

//     setRenewalData({
//       start_date: "",
//     });

//     setRenewalOpen(true);
//   };

//   // ONLY SUBSCRIPTION CODE

//   const handleSaveSubscription = async () => {
//     if (!selectedDevice) return;

//     if (!subscriptionData.start_date) {
//       toast.error("Please select start date");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${API_URL}/api/subscriptions/process-payment/${selectedDevice.device_id}/`,
//         {
//           start_date: subscriptionData.start_date,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       toast.success(
//         response.data.message || "Subscription added successfully"
//       );

//       setSubscriptionOpen(false);

//       setSubscriptionData({
//         start_date: "",
//       });

//     } catch (error) {
//       console.error(error);

//       toast.error(
//         error.response?.data?.error ||
//         "Failed to create subscription"
//       );
//     }
//   };

//   const handleSaveRenewal = async () => {
//     if (!selectedDevice) return;

//     try {
//       const response = await axios.post(
//         `${API_URL}/api/subscriptions/process-payment/${selectedDevice.device_id}/`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       toast.success(
//         response.data.message || "Subscription renewed successfully"
//       );

//       setRenewalOpen(false);
//       setRenewalData({
//         start_date: "",
//       });

//     } catch (error) {
//       console.error(error);

//       toast.error(
//         error.response?.data?.error ||
//         "Failed to renew subscription"
//       );
//     }
//   };

//   return (
//     <Box className="view-devices-container">
//       <FormControl className="site-select-container" fullWidth sx={{ mb: 2 }}>
//         <InputLabel>Select Site</InputLabel>
//         <Select
//           value={selectedSite}
//           label="Select Site"
//           onChange={(e) => setSelectedSite(e.target.value)}
//         >
//           <MenuItem value="all">All</MenuItem>
//           {sites.map((site) => (
//             <MenuItem key={site.site_id} value={site.asset_id}>
//               {site.name}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//       <TableContainer component={Paper} className="device-table">
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Sr No</TableCell>
//               <TableCell>Device Name</TableCell>

//               {/* <TableCell>Subscription Status</TableCell> */}
//               <TableCell>Subscription Start Date</TableCell>
//               <TableCell>Subscription End Date</TableCell>

//               <TableCell>Subscription Status</TableCell>
//               <TableCell align="center">Actions</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {loading ? (
//               <TableRow>
//                 <TableCell colSpan={6} align="center">
//                   <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//                     <CircularProgress />
//                   </Box>
//                 </TableCell>
//               </TableRow>
//             ) : devices.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={6} align="center">
//                   No devices found.
//                 </TableCell>
//               </TableRow>
//             ) : (
//               devices
//                 .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                 .map((device, index) => (
//                   <TableRow key={device.id}>
//                     <TableCell>{page * rowsPerPage + index + 1}</TableCell>

//                     <TableCell>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         {device.device_name}
//                       </Box>
//                     </TableCell>

//                     {/* <TableCell>{device.device_id}</TableCell> */}

//                     <TableCell>{device.start_date}</TableCell>

//                     <TableCell>{device.end_date}</TableCell>

//                     <TableCell>
//                       <span
//                         style={{
//                           color:
//                             device.subscription_status === "ACTIVE"
//                               ? "green"
//                               : device.subscription_status === "INACTIVE"
//                                 ? "orange"
//                                 : device.subscription_status === "DISABLED"
//                                   ? "#9c27b0" // purple (you can change)
//                                   : "red",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {device.subscription_status}
//                       </span>
//                     </TableCell>
//                     <TableCell align="center">
//                       <IconButton
//                         color="primary"
//                         onClick={() => handleEditClick(device)}
//                       >
//                         <EditIcon />
//                       </IconButton>

//                       <IconButton
//                         color="error"
//                         onClick={() => handleDeleteClick(device)}
//                       >
//                         <DeleteIcon />
//                       </IconButton>

//                       {["ACTIVE", "INACTIVE", "DISABLED"].includes(device.subscription_status) ? (
//                         <IconButton
//                           sx={{ color: "#2e7d32" }}
//                           onClick={() => handleRenewalClick(device)}
//                           title="Renew Subscription"
//                         >
//                           <AutorenewIcon />
//                         </IconButton>
//                       ) : (
//                         <IconButton
//                           sx={{ color: "#1976d2" }}
//                           onClick={() => handleSubscriptionClick(device)}
//                           title="Add Subscription"
//                         >
//                           <SubscriptionsIcon />
//                         </IconButton>
//                       )}
//                     </TableCell>
//                   </TableRow>
//                 )))}
//           </TableBody>
//         </Table>

//         {/* Add this block after </Table> */}
//         <div className="pagination-bar">
//           <div className="rows-select">
//             Rows per page:
//             <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
//               <option value={5}>5</option>
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//             </select>
//           </div>
//           <div className="page-info">
//             {devices.length > 0 ? page * rowsPerPage + 1 : 0}-
//             {Math.min((page + 1) * rowsPerPage, devices.length)} of{" "}
//             {devices.length}
//           </div>
//           <div className="page-arrows">
//             <button disabled={page === 0} onClick={() => setPage(page - 1)}>
//               ‹
//             </button>
//             <button
//               disabled={(page + 1) * rowsPerPage >= devices.length}
//               onClick={() => setPage(page + 1)}
//             >
//               ›
//             </button>
//           </div>
//         </div>
//       </TableContainer>

//       <EditDevice
//         open={editOpen}
//         onClose={() => setEditOpen(false)}
//         device={deviceToEdit}
//         onSave={handleSaveEdit}
//       />







//       <Dialog
//         open={subscriptionOpen}
//         onClose={() => setSubscriptionOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Add Subscription</DialogTitle>

//         <DialogContent sx={{ mt: 1 }}>
//           <TextField
//             fullWidth
//             label="Start Date"
//             type="date"
//             margin="normal"
//             InputLabelProps={{ shrink: true }}
//             value={subscriptionData.start_date}
//             onChange={(e) =>
//               setSubscriptionData({
//                 ...subscriptionData,
//                 start_date: e.target.value,
//               })
//             }
//           />
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={() => setSubscriptionOpen(false)}>
//             Cancel
//           </Button>

//           <Button
//             variant="contained"
//             onClick={handleSaveSubscription}
//           >
//             Save
//           </Button>
//         </DialogActions>
//       </Dialog>


//       {/* RENEWAL POPUP */}
//       <Dialog
//         open={renewalOpen}
//         onClose={() => setRenewalOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Renew Subscription</DialogTitle>

//         <DialogContent sx={{ mt: 1 }}>
//           <TextField
//             fullWidth
//             label="Start Date"
//             type="date"
//             margin="normal"
//             InputLabelProps={{ shrink: true }}
//             value={renewalData.start_date}
//             onChange={(e) =>
//               setRenewalData({
//                 ...renewalData,
//                 start_date: e.target.value,
//               })
//             }
//           />


//         </DialogContent>

//         <DialogActions>
//           <Button onClick={() => setRenewalOpen(false)}>Cancel</Button>
//           <Button
//             variant="contained"
//             color="success"
//             onClick={handleSaveRenewal}
//           >
//             Renew
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Dialog */}
//       <Dialog open={deleteOpen} onClose={handleCancelDelete}>
//         <DialogTitle>Delete Device</DialogTitle>

//         <DialogContent>
//           <DialogContentText>
//             {!deleteMessage && "Are you sure to delete this device?"}
//           </DialogContentText>

//           {/* ✅ Backend Message */}
//           {deleteMessage && (
//             <Box
//               sx={{
//                 mt: 2,
//                 p: 2,
//                 borderRadius: 2,
//                 backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
//                 color: deleteError ? "#d32f2f" : "#2e7d32",
//                 fontWeight: 500,
//               }}
//             >
//               {deleteMessage}
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions>
//           {/* ❌ Error → Only OK */}
//           {deleteError && deleteMessage ? (
//             <Button
//               onClick={handleCancelDelete}
//               variant="contained"
//               color="primary"
//             >
//               OK
//             </Button>
//           ) : deleteMessage && !deleteError ? (
//             /* ✅ Success → Done */
//             <Button
//               onClick={handleCancelDelete}
//               variant="contained"
//               color="success"
//             >
//               Done
//             </Button>
//           ) : (
//             /* 🟢 Default → Cancel + Delete */
//             <>
//               <Button onClick={handleCancelDelete} variant="outlined">
//                 Cancel
//               </Button>

//               <Button
//                 onClick={handleConfirmDelete}
//                 variant="contained"
//                 color="error"
//               >
//                 Delete
//               </Button>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ViewDevicesSubscription;









import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { CircularProgress } from "@mui/material";
import { TextField } from "@mui/material";


import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DevicesIcon from "@mui/icons-material/Devices";
import EditDevice from "./EditDevice";
import "./ViewDevice.css";
import apiService from "../../utils/apiservice";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";





const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const ViewDevicesSubscription = () => {
  const [devices, setDevices] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deviceToDelete, setDeviceToDelete] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deviceToEdit, setDeviceToEdit] = useState(null);
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("all"); // default to All
  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");
  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleteError, setDeleteError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);
  const [renewalOpen, setRenewalOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState({
    start_date: "",

  });
const [renewalErrors, setRenewalErrors] = useState({
  start_date: "",
});
  const [renewalData, setRenewalData] = useState({
    start_date: "",

  });


  // Add these inside your ViewSites component
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // Add these handlers below your state definitions
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchSites = async () => {
      try {
        // const response = await axios({
        //   url: `${API_URL}/api/get_customer_sites/${customerId}/`,
        //   method: "GET",
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        //   },
        //   data: {}, // 🔥 IMPORTANT: forces Content-Type header
        // });

        const response = await apiService({
          url: `/api/get_customer_sites/${customerId}/`,
          method: "GET",
          data: {}, // ✅ keep as it is
        });

        const siteData = response.data.data;
        // setSites(siteData);
        // if (siteData.length > 0) {
        //   setSelectedSite(siteData[0].asset_id);
        // }

        setSites(siteData);
        // Only set default to first site if selectedSite is empty
        if (!selectedSite || selectedSite === "all") {
          setSelectedSite("all"); // Keep default as "all"
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    if (customerId) fetchSites();
  }, [customerId, token]);
const fetchDevices = async () => {
  if (!customerId) return;

  setLoading(true);

  try {
    let deviceList = [];

    if (selectedSite === "all") {
      const response = await axios.get(
        `${API_URL}/api/customer_alldevices/${customerId}/?page=0&pageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data:{},
        }
      );

      const allDevices = response.data.data.data || [];

      deviceList = allDevices.map((device, index) => ({
        id: index + 1,
        device_id: device.id.id,
        device_name: device.name,
        is_enabled: device.active ?? false,
        subscription_status:
          device.subscription?.status || "UNSUBSCRIBED",
        start_date: device.subscription?.start_date || "-",
        end_date: device.subscription?.end_date || "-",
        renewal_date: device.subscription?.renewal_date || "-",
      }));
    } else {
      const response = await axios.get(
        `${API_URL}/api/site_devices/${selectedSite}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const siteDevices = response.data.devices || [];

      deviceList = siteDevices.map((device, index) => ({
        id: index + 1,
        device_id: device.device_id,
        device_name: device.device_name,
        is_enabled: device.active ?? false,
        subscription_status:
          device.subscription?.status || "UNSUBSCRIBED",
        start_date: device.subscription?.start_date || "-",
        end_date: device.subscription?.end_date || "-",
        renewal_date: device.subscription?.renewal_date || "-",
      }));
    }

    setDevices(deviceList);
  } catch (error) {
    console.error("Error fetching devices:", error);
    setDevices([]);
  }

  setLoading(false);
};


useEffect(() => {
  fetchDevices();
}, [selectedSite, token, customerId]);

  const handleEditClick = (device) => {
    setDeviceToEdit(device);
    setEditOpen(true);
  };

  const handleSaveEdit = (updatedDevice) => {
    // Map through devices and replace the one with the matching ID
    setDevices(
      devices.map((d) => (d.id === updatedDevice.id ? updatedDevice : d)),
    );
    setEditOpen(false);
  };

  const handleDeleteClick = (device) => {
    setDeviceToDelete(device);
    setDeleteOpen(true);
    setDeleteMessage("");
    setDeleteError(false);
  };

  const handleConfirmDelete = async () => {
    if (!deviceToDelete) return;

    try {
      
      const response = await apiService({
        url: `/api/delete_device/${deviceToDelete.device_id}/`,
        method: "DELETE",
        data: {}, // ✅ keep
      });

      // ✅ Success
      const msg = response.data.message || "Device deleted successfully!";
      setDeleteMessage(msg);
      setDeleteError(false);

      // Optional toast
      // toast.success(msg);

      setTimeout(() => {
        setDevices(devices.filter((d) => d.id !== deviceToDelete.id));
        setDeleteOpen(false);
        setDeleteMessage("");
      }, 1500);
    } catch (error) {
      console.error("Error deleting device:", error);

      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to delete device.";

      setDeleteMessage(backendMessage);
      setDeleteError(true);

      // toast.error(backendMessage);
    }
  };
  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteMessage("");
    setDeleteError(false);
  };


  const handleSubscriptionClick = (device) => {
    setSelectedDevice(device);
    setSubscriptionOpen(true);
  };

  const handleRenewalClick = (device) => {
    setSelectedDevice(device);

    setRenewalData({
      start_date: "",
    });

    setRenewalOpen(true);
  };

  // ONLY SUBSCRIPTION CODE

  const handleSaveSubscription = async () => {
    if (!selectedDevice) return;

    if (!subscriptionData.start_date) {
      toast.error("Please select start date");
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/api/subscriptions/process-payment/${selectedDevice.device_id}/`,
        {
          start_date: subscriptionData.start_date,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(
        response.data.message || "Subscription added successfully"
      );

      await fetchDevices();

      setSubscriptionOpen(false);

      setSubscriptionData({
        start_date: "",
      });

    } catch (error) {
      console.error(error);

      toast.error(
        error.response?.data?.error ||
        "Failed to create subscription"
      );
    }
  };

  const handleSaveRenewal = async () => {
  if (!selectedDevice) return;

  // Validation
  if (!renewalData.start_date) {
    setRenewalErrors({
      start_date: "Please select a renewal start date",
    });
    return;
  }

  setRenewalErrors({
    start_date: "",
  });

  try {
    const response = await axios.post(
      `${API_URL}/api/subscriptions/process-payment/${selectedDevice.device_id}/`,
      {
        start_date: renewalData.start_date,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    toast.success(
      response.data.message || "Subscription renewed successfully"
    );

    await fetchDevices();

    setRenewalOpen(false);

    setRenewalData({
      start_date: "",
    });
  } catch (error) {
    console.error(error);

    toast.error(
      error.response?.data?.error ||
      "Failed to renew subscription"
    );
  }
};

  return (
    <Box className="view-devices-container">
      <FormControl className="site-select-container" fullWidth sx={{ mb: 2 }}>
        <InputLabel>Select Site</InputLabel>
        <Select
          value={selectedSite}
          label="Select Site"
          onChange={(e) => setSelectedSite(e.target.value)}
        >
          <MenuItem value="all">All</MenuItem>
          {sites.map((site) => (
            <MenuItem key={site.site_id} value={site.asset_id}>
              {site.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TableContainer component={Paper} className="device-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Device Name</TableCell>

              {/* <TableCell>Subscription Status</TableCell> */}
              <TableCell>Subscription Start Date</TableCell>
              <TableCell>Subscription End Date</TableCell>
                <TableCell>Renewal Date</TableCell>  
              <TableCell>Subscription Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            ) : devices.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No devices found.
                </TableCell>
              </TableRow>
            ) : (
              devices
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((device, index) => (
                  <TableRow key={device.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>

                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {device.device_name}
                      </Box>
                    </TableCell>

                    {/* <TableCell>{device.device_id}</TableCell> */}

                    <TableCell>{device.start_date}</TableCell>

                    <TableCell>{device.end_date}</TableCell>
                   <TableCell>{device.renewal_date}</TableCell> 
                    <TableCell>
                      <span
                        style={{
                          color:
                            device.subscription_status === "ACTIVE"
                              ? "green"
                              : device.subscription_status === "INACTIVE"
                                ? "orange"
                                : device.subscription_status === "DISABLED"
                                  ? "#9c27b0" // purple (you can change)
                                  : "red",
                          fontWeight: "bold",
                        }}
                      >
                        {device.subscription_status}
                      </span>
                    </TableCell>
                    <TableCell align="center">
                      {/* <IconButton
                        color="primary"
                        onClick={() => handleEditClick(device)}
                      >
                        <EditIcon />
                      </IconButton>

                      <IconButton
                        color="error"
                        onClick={() => handleDeleteClick(device)}
                      >
                        <DeleteIcon />
                      </IconButton> */}

                      {["ACTIVE", "INACTIVE", "DISABLED"].includes(device.subscription_status) ? (
                        <IconButton
                          sx={{ color: "#2e7d32" }}
                          onClick={() => handleRenewalClick(device)}
                          title="Renew Subscription"
                        >
                          <AutorenewIcon />
                        </IconButton>
                      ) : (
                        <IconButton
                          sx={{ color: "#1976d2" }}
                          onClick={() => handleSubscriptionClick(device)}
                          title="Add Subscription"
                        >
                          <SubscriptionsIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                )))}
          </TableBody>
        </Table>

        {/* Add this block after </Table> */}
        <div className="pagination-bar">
          <div className="rows-select">
            Rows per page:
            <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
            </select>
          </div>
          <div className="page-info">
            {devices.length > 0 ? page * rowsPerPage + 1 : 0}-
            {Math.min((page + 1) * rowsPerPage, devices.length)} of{" "}
            {devices.length}
          </div>
          <div className="page-arrows">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>
              ‹
            </button>
            <button
              disabled={(page + 1) * rowsPerPage >= devices.length}
              onClick={() => setPage(page + 1)}
            >
              ›
            </button>
          </div>
        </div>
      </TableContainer>

      <EditDevice
        open={editOpen}
        onClose={() => setEditOpen(false)}
        device={deviceToEdit}
        onSave={handleSaveEdit}
      />







      <Dialog
        open={subscriptionOpen}
        onClose={() => setSubscriptionOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add Subscription</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="Start Date"
            type="date"
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={subscriptionData.start_date}
            onChange={(e) =>
              setSubscriptionData({
                ...subscriptionData,
                start_date: e.target.value,
              })
            }
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setSubscriptionOpen(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSaveSubscription}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>


      {/* RENEWAL POPUP */}
      <Dialog
        open={renewalOpen}
        onClose={() => setRenewalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Renew Subscription</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
         <TextField
  fullWidth
  label="Start Date  "
  type="date"
  margin="normal"
  InputLabelProps={{ shrink: true }}
  value={renewalData.start_date}
  onChange={(e) => {
    setRenewalData({
      ...renewalData,
      start_date: e.target.value,
    });

    setRenewalErrors({
      ...renewalErrors,
      start_date: "",
    });
  }}
  error={!!renewalErrors.start_date}
  helperText={renewalErrors.start_date}
/>


        </DialogContent>

        <DialogActions>
          <Button onClick={() => setRenewalOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleSaveRenewal}
          >
            Renew
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={deleteOpen} onClose={handleCancelDelete}>
        <DialogTitle>Delete Device</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {!deleteMessage && "Are you sure to delete this device?"}
          </DialogContentText>

          {/* ✅ Backend Message */}
          {deleteMessage && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
                color: deleteError ? "#d32f2f" : "#2e7d32",
                fontWeight: 500,
              }}
            >
              {deleteMessage}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          {/* ❌ Error → Only OK */}
          {deleteError && deleteMessage ? (
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          ) : deleteMessage && !deleteError ? (
            /* ✅ Success → Done */
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="success"
            >
              Done
            </Button>
          ) : (
            /* 🟢 Default → Cancel + Delete */
            <>
              <Button onClick={handleCancelDelete} variant="outlined">
                Cancel
              </Button>

              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                color="error"
              >
                Delete
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewDevicesSubscription;